import { render, staticRenderFns } from "./PppoeplusConfig.vue?vue&type=template&id=4dbafac5&"
import script from "./PppoeplusConfig.vue?vue&type=script&lang=js&"
export * from "./PppoeplusConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports